import { gql } from '@apollo/client';

export const CREATE_DOOPIE_REGISTER_MUTATION = gql`
  mutation createDoopieRegister($data: CreateDoopieRegisterInput!) {
    createDoopieRegister(data: $data) {
      id
      solanaAddress
    }
  }
`;
